// extracted by mini-css-extract-plugin
module.exports = {"list":"list___6FCiP","is-grid":"is-grid___tNO9S"};